import { FromLinkedIn } from './ClassicCVCareer.types';

// Constants.
// -----------------------------------------------------------------------------
export const DEFAULT_FROM_LINKENDIN: FromLinkedIn = {
  jobs: false
};

export const TIMELINE_CARD_TYPE = 'career';
